// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { copyText16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-copy-text': IconCopyText;
    }
}

/**
 * The icon component for the 'copyText' icon
 */
export class IconCopyText extends Icon {
    public constructor() {
        super(copyText16X16);
    }
}

registerIcon('icon-copy-text', IconCopyText);
export const iconCopyTextTag = 'nimble-icon-copy-text';
